import { RestModels } from "tradehub-api-js";

export const sortOrder = (lhs: RestModels.Order, rhs: RestModels.Order) => {
  return parseInt(rhs.id) - parseInt(lhs.id);
}

export const arrayEquals = (lhs: Uint8Array, rhs: Uint8Array) => {
  return lhs.every((value, index) => rhs[index] === value);
}
